import { Grid2 } from "@mui/material"

export default function ModeButton({...params}){

    let pageMode = params.pageMode
    let setPageMode = params.setPageMode

    const togglePageMode = () => {
        if (pageMode === 'read') setPageMode('edit')
        else if (pageMode === 'edit' || pageMode === 'schedule') setPageMode('read')
    }

    return (
        <>
            {(pageMode === 'read') && (
                <Grid2>
                    <button onClick={togglePageMode}>Toggle to Edit Mode</button>
                </Grid2>
            )}

            {(pageMode === 'edit' || pageMode === 'schedule') && (
                <Grid2>
                    <button onClick={togglePageMode}>Toggle to Read Mode</button>
                </Grid2>
            )}
        </>
    )
}
